module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-classic-1-2e32014111e0f332caaf449ad2a56b5d.webp";